import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import Card from "components/cards/Card";
import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import Card1 from "assets/images/causes/Card1.png";
import Card2 from "assets/images/causes/Card2.png";
import Card3 from "assets/images/causes/Card3.png";
import Card4 from "assets/images/causes/cau3.png";
import PTE from "assets/images/causes/PTE.png";

export default function CauseCards({ id }) {
  const classes = useStyles();
  const history = useHistory();
  
  return (
    <Card className={classes.causeCards}>
      <Grid container spacing={3}>
        {id != 2 && (
          <Grid
            className={classes.causeCard}
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            xl={4}
            onClick={() => {
              history.push("/causes-details/2");
            }}
          >
            <img
              src={Card4}
              width="100%"
              style={{
                height: "100%",
                borderRadius: 10,
                objectFit: "cover",
              }}
            />
          </Grid>
        )}
        {id != 1 && (
          <Grid
            className={classes.causeCard}
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            xl={4}
            onClick={() => {
              history.push("/causes-details/1");
            }}
          >
            <img
              src={Card1}
              width="100%"
              style={{
                height: "100%",
                borderRadius: 10,
                objectFit: "cover",
              }}
            />
          </Grid>
        )}
        {id != 3 && (
          <Grid
            className={classes.causeCard}
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            xl={4}
            onClick={() => {
              history.push("/causes-details/3");
            }}
          >
            <img
              src={Card2}
              width="100%"
              style={{
                height: "100%",
                borderRadius: 10,
                objectFit: "cover",
              }}
            />
          </Grid>
        )}
        {(id != 4 && id != 39 && id != 41) && (
          <Grid
            className={classes.causeCard}
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            xl={4}
            onClick={() => {
              history.push("/causes-details/4");
            }}
          >
            <img
              src={Card3}
              width="100%"
              style={{
                height: "100%",
                borderRadius: 10,
                objectFit: "cover",
              }}
            />
            <img className={classes.pte} src={PTE} />
          </Grid>
        )}
      </Grid>
    </Card>
  );
}

const useStyles = makeStyles((theme) => ({
  causeCards: {
    position: "relative",
    top: "-55px",
    boxShadow: "0px 2px 0px #e5e9f2",

    "& .MuiCardContent-root": {
      padding: "35px 40px 35px",
    },
  },
  pte: {
    position: "relative",
    top: "-65px",
    width: "72%",
    left: "55px",
  },
  causeCard: {
    cursor: "pointer",
    // height: "200px",
  },
}));
